import { getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { __module as withSelector } from '../../../_virtual/with-selector.js';
import { __require as requireWithSelector_production } from '../cjs/use-sync-external-store-shim/with-selector.production.js';
import { __require as requireWithSelector_development } from '../cjs/use-sync-external-store-shim/with-selector.development.js';

if(process.env.NODE_ENV==="production"){withSelector.exports=requireWithSelector_production();}else {withSelector.exports=requireWithSelector_development();}var withSelectorExports=withSelector.exports;var useSyncExternalStoreExports = getDefaultExportFromCjs(withSelectorExports);

export { useSyncExternalStoreExports as default };
//# sourceMappingURL=with-selector.js.map
